<template>
	<load
		v-if="load"
		color="#f0f8ff"
		mode="table"
		message="Carregando conversa"
		style="height: 100% !important"
	/>
	<div style="height: 100%" v-else>
		<div
			class="rounded"
			style="background: aliceblue; height: 80%; overflow-y: auto; overflow-x: hidden"
			id="msn-list"
		>
			<MessagesFeedGroup
				v-if="type == 'grupos'"
				:contact="contact"
				:messages="messages"
				:type="type"
			/>
			<MessagesFeed
				v-else
				:contact="contact"
				:messages="messages"
				:loadmessage="loadmessage"
				:writemessage="writemessage"
				:type="type"
				:box="box"
			/>
		</div>
		<MessageComposer
			v-if="contact"
			@send="sendMessage"
			@writing="$emit('writing')"
			@stop-writing="$emit('stop-writing')"
		/>
	</div>
</template>

<script>
import MessagesFeed from "./MessagesFeed";
import MessagesFeedGroup from "./MessagesFeedGroup";
import MessageComposer from "./MessageComposer";

export default {
	props: {
		contact: {
			type: Object,
			default: null,
		},
		messages: {
			type: Array,
			default: [],
		},
		load: { type: Boolean, default: false },
		type: { type: String, default: "contatos" },
		box: { type: String, default: "chat" },
		writemessage: { type: Boolean, default: false },
	},
	data() {
		return {
			loading: false,
			loadmessage: false,
		};
	},

	with: {
		load() {
			this.loading = this.load;
		},
	},
	mounted() {
		this.loading = this.load;
	},
	methods: {
		sendMessage(text) {
			this.loading = true;
			if (!this.contact) {
				return;
			}
			// $(".load-text").css("display", "block");
			if (text) {
				setTimeout(() => {
					document.getElementById("msn-list").scroll({
						top: document.getElementById("msn-list").scrollHeight,
						left: 0,
						behavior: "smooth",
					});
				}, 50);
				this.loadmessage = true;
				axios
					.post("api/dashboard/chat/conversation/send", {
						contact_id: this.contact.id,
						type: this.type,
						text: text,
					})
					.then((response) => {
						this.$emit("new", response.data);
						// $(".load-text").css("display", "none");
					})
					.finally(() => {
						this.loading = false;
						this.loadmessage = false;
					});
			}
		},
	},
	components: { MessagesFeed, MessageComposer, MessagesFeedGroup },
};
</script>

<style>
body .direct-chat-info .right > .direct-chat-text {
	background: #00a0a9;
	border-color: #00a0a9;
	color: #fff;
}

.direct-chat-info .right > .direct-chat-text:after,
.direct-chat-info .right > .direct-chat-text:before {
	border-left-color: #00a0a9;
}

.direct-chat-info {
	display: block;
	margin-bottom: 2px;
	font-size: 14px;
}
.conversation {
	/* height: 60vh !important; */
	/* width: -webkit-fill-available; */
	background: aliceblue;
	width: 100%;
	/* overflow: auto;
    overflow-x: hidden; */
}
</style>
